module.exports = __webpack_public_path__ + "media/images/beate_canigou-f4267df4b6c70279ebec469fda2ae42e.png";